module.exports = __webpack_public_path__ + "static/media/pin_farmacia.4eb3853c.png";